<template>
    <div>
        <div class="dc-button-row"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <div class="dc-btn"
                :class="{'active': activeTab == 'not_use'}"
                @click="clickChangeTab('not_use')">
                <div class="dc-inner-btn">{{lbl.history.burn_tab}}</div>
            </div>
            <div class="dc-btn"
                :class="{'active': activeTab == 'used'}"
                @click="clickChangeTab('used')">
                <div class="dc-inner-btn">{{lbl.history.used_tab}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HistoryTab',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lbl: Object,
        activeTabProp: String,
        historyController: Object
    },
    data:function(){
        return {
            activeTab: this.activeTabProp
        }
    },
    methods: {
        clickChangeTab: function(tab) {
            this.activeTab = tab;
            this.historyController.changeMode(tab);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import '@/style/base/button.scss';
#history_tab_wrapper {
    @extend %display-flex;

    .history-tab {
        width: 50%;
        flex: 0 0 50%;
    }
}

.dc-button-row {
    @extend %display-flex;
    box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.16);

    .dc-btn {
        width: 50%;
        flex: 0 0 50%;
        padding: 10px 0;

        .dc-inner-btn {
            opacity: 0.51;
            font-size: 1.125rem;
            // font-family: $heading;
            text-align: center;
            // line-height: 1;
        }
    }

    &.mass {
        background: $mass_theme_color;

        .dc-btn {
            .dc-inner-btn {
                color: $mass_font_color_3;
            }
            &.active {
                @extend %base-mass-btn-bg;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;

                .dc-inner-btn {
                    color: #ffffff;
                    opacity: 1;
                }
            }
        }
    }

    &.prestige {
        background: $prestige_theme_color;

        .dc-btn {
            .dc-inner-btn {
                color: #ffffff;
            }

            &.active {
                @extend %base-prestige-btn-bg;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;

                .dc-inner-btn {
                    color: #ffffff;
                    opacity: 1;
                }
            }
        }
    }
}
</style>
